import { Component, Input } from '@angular/core';
import { ServiceStatusLevel } from 'src/app/base/models/models.swagger.generated';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-status-badge',
  templateUrl: './status-badge.component.html',
  styleUrls: ['./status-badge.component.scss'],
  imports: [TranslateModule]
})
export class StatusBadgeComponent {
  @Input() status: ServiceStatusLevel | undefined;

  public get statusClass(): string {
    switch (this.status) {
      case ServiceStatusLevel.Operational:
        return 'badge-operational';
      case ServiceStatusLevel.Degraded:
        return 'badge-degraded';
      case ServiceStatusLevel.Down:
        return 'badge-down';
      default:
        return 'badge-unknown';
    }
  }

  public get statusKey(): string {
    switch (this.status) {
      case ServiceStatusLevel.Operational:
        return 'i18n.domain.status.levels.operational';
      case ServiceStatusLevel.Degraded:
        return 'i18n.domain.status.levels.degraded';
      case ServiceStatusLevel.Down:
        return 'i18n.domain.status.levels.down';
      default:
        return 'i18n.domain.status.levels.unknown';
    }
  }
}
